export default __webpack_public_path__ + "images/optionUnavailable__f4b44346c99afd56e901c04d8443f424.png";